import { render, staticRenderFns } from "./PanicForm.vue?vue&type=template&id=10e28293"
import script from "./PanicForm.vue?vue&type=script&lang=ts"
export * from "./PanicForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports